import React from "react";
import { CSVLink } from "react-csv";
import { useReportContext } from "../ReportDataContext";
import SchoolProgramFilters, {
  useSchoolProgramFilters,
} from "../SchoolProgramFilters";
import SchoolProgramReportTable from "./SchoolProgramReportTable";
import { schoolProgramHeaders } from "./SchoolProgramCSVHeaders";

export default function SchoolProgramReportView({ reports }) {
  const branch = useReportContext().AUTH.branch;

  // The school-program report endpoint returns the program name as `program_type`.
  const { filteredReports, filters } = useSchoolProgramFilters(reports, branch, {
    programField: "program_type",
  });

  return (
    <div>
      <SchoolProgramFilters filters={filters} />

      <div className="row mb-3">
        <div className="col-12 text-right">
          {filteredReports.length > 0 && (
            <button type="button" className="btn btn-primary">
              <CSVLink
                className="text-white"
                filename={`${branch.branch_name} - Registered Student List - School Program - Report.csv`}
                data={filteredReports}
                headers={schoolProgramHeaders}
              >
                Download Report
              </CSVLink>
            </button>
          )}
        </div>
      </div>

      {filteredReports.length > 0 ? (
        <SchoolProgramReportTable reports={filteredReports} showActions={false} />
      ) : (
        <div className="text-muted mt-3">No results match the selected filters.</div>
      )}
    </div>
  );
}
